import { Button, Tooltip } from "antd";
import useActionDialogRefine from "hook/bailiff/dialog/useActionDialog";
import React from "react";
import { IoPlaySkipForward, IoPlaySkipForwardOutline } from "react-icons/io5";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ButtonNext = () => {
  // -------------------------- VAR -----------------------------
  const { handleNextDialog } = useActionDialogRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Tooltip title="Nhảy sang đoạn kế tiếp">
      <Button
        onClick={handleNextDialog}
        type="text"
        size="large"
        icon={<IoPlaySkipForwardOutline />}
      />
    </Tooltip>
  );
};
export default ButtonNext;
